import { render, staticRenderFns } from "./Waitlist.vue?vue&type=template&id=0f1a2de6&scoped=true"
import script from "./Waitlist.vue?vue&type=script&lang=js"
export * from "./Waitlist.vue?vue&type=script&lang=js"
import style0 from "./Waitlist.vue?vue&type=style&index=0&id=0f1a2de6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f1a2de6",
  null
  
)

export default component.exports